export { OrderDetailV2Nominee } from "./OrderDetailV2Nominee";
